import { useEffect } from "react";

const HomeRedirect: React.FC<any> = () => {
  const Redirect = () => {
    return window.location.href = process.env.PUBLIC_URL;
  };
  useEffect(() => {
    Redirect();
  }, []);
  return (<></>);
};

export default HomeRedirect;